import axios from "../../../shared/axios/axiosProxy.js";
import { getIndustryFinancialDefaults } from "./industryFinancialDefaults.js";

const isValidSearchID = (searchID) =>
  searchID && searchID !== "undefined" && searchID !== "null";

/** Redux-only: industry-based yearlyrevenue + invoice defaults (ASP / top3 matching). */
export const applyIndustryFinancialDefaultsToStore = ({
  industry,
  addCompanyInfo,
}) => {
  if (!industry || typeof addCompanyInfo !== "function") {
    return null;
  }

  const financialDefaults = getIndustryFinancialDefaults(industry);
  if (!financialDefaults) {
    return null;
  }

  addCompanyInfo({
    id: "yearlyrevenue",
    data: financialDefaults.yearlyrevenue,
    stateObject: "company_store",
  });
  addCompanyInfo({
    id: "yearlyrevenueSource",
    data: "default",
    stateObject: "company_store",
  });
  addCompanyInfo({
    id: "incominginvoices",
    data: financialDefaults.incominginvoices,
    stateObject: "company_store",
  });
  addCompanyInfo({
    id: "incominginvoicesSource",
    data: "default",
    stateObject: "company_store",
  });
  addCompanyInfo({
    id: "outgoinginvoices",
    data: financialDefaults.outgoinginvoices,
    stateObject: "company_store",
  });
  addCompanyInfo({
    id: "outgoinginvoicesSource",
    data: "default",
    stateObject: "company_store",
  });

  return financialDefaults;
};

/**
 * Sets industry + financial defaults in Redux and persists them to searchSchema.
 * Await before navigating on the Cégjelző auto path so a step change cannot
 * overwrite freshly written values with stale store data.
 *
 * Clearing industry (`""`) only updates Redux synchronously — no financial patch.
 */
export const persistIndustryWithFinancialDefaults = async ({
  industry,
  searchID,
  addCompanyInfo,
  clearIndustryInputWhenNotOther = false,
  industrySource = "user",
}) => {
  addCompanyInfo({
    id: "industry",
    data: industry,
    stateObject: "company_store",
  });
  addCompanyInfo({
    id: "industrySource",
    data: industrySource,
    stateObject: "company_store",
  });

  if (!industry) {
    return null;
  }

  const shouldClearIndustryInput =
    industry !== "other" && clearIndustryInputWhenNotOther;

  if (shouldClearIndustryInput) {
    addCompanyInfo({
      id: "industryinput",
      data: "",
      stateObject: "company_store",
    });
  }

  const financialDefaults = applyIndustryFinancialDefaultsToStore({
    industry,
    addCompanyInfo,
  });
  if (!financialDefaults) {
    return null;
  }

  if (!isValidSearchID(searchID)) {
    return { industry, ...financialDefaults };
  }

  const patchPayload = {
    industry,
    yearlyrevenue: financialDefaults.yearlyrevenue,
    incominginvoices: financialDefaults.incominginvoices,
    outgoinginvoices: financialDefaults.outgoinginvoices,
  };

  if (shouldClearIndustryInput) {
    patchPayload.industryinput = "";
  }

  await axios.patch(`/api/search/${searchID}`, patchPayload, {
    headers: { "Content-Type": "application/json" },
  });

  return { industry, ...financialDefaults };
};
